<template>
  <div id="app">
    <div class="container">
      <nav>
        <img id="boveda-logo" alt="Boveda logo" src="/img/Boveda_Logo.svg" />
      </nav>
      <div class="center" style="max-width: 500px; min-width: 280px">
        <div id="splash" class="center">
          <h1>STOP LOSING MONEY EVERY HARVEST</h1>
        </div>
        <div class="center content">
          <span
            class="center"
          >In storage, flower immediately begins to lose the life-giving water that gives her weight. Boveda helps you prevent evaporation which results in heavier flower and increased profit.</span>
        </div>
        <div id="calculator">
          <h2 class="center">CALCULATE HOW MUCH YOUR INCOME IS EVAPORATING</h2>
          <div class="blue_banner">
            <h3 class="center">Select Your Current Price, Weight and Relative Humidity</h3>
          </div>
          <div class="slider center">
            <h4 class="center">MY AVERAGE SALE PRICE PER GRAM</h4>
            <h4>${{price}} / G</h4>
            <input
              type="range"
              min="1"
              max="21"
              v-model.number="price"
              class="slider_common brown_slider"
            />
            <br />
            <br />
          </div>
          <div class="slider">
            <h4>CANNABIS PRODUCED PER HARVEST</h4>
            <h4>{{output}} LBS</h4>
            <input
              type="range"
              min="20"
              max="5000"
              step="20"
              v-model.number="output"
              class="slider_common brown_slider"
            />
            <br />
            <br />
          </div>
          <div class="slider" style="border-bottom: 0">
            <h4>CURRENT RELATIVE HUMIDITY (RH)</h4>
            <h4>{{currentRh}} RH*</h4>
            <input
              type="range"
              min="20"
              max="80"
              v-model.number="currentRh"
              class="slider_common rainbow_slider"
            />
            <div class="center note">*{{ footNote }}</div>
            <br />
            <br />
          </div>
          <br />
          <h3 class="center">TARGET RELATIVE HUMIDITY</h3>
          <br />
          <div class="toggleContainer">
            <div
              class="currency center"
              :class="{selected: (targetRh == 58)}"
              @click="targetRh = 58"
            >58%</div>
            <div
              class="currency center"
              :class="{selected: (targetRh == 62)}"
              @click="targetRh = 62"
            >62%</div>
            <div style="clear:both"></div>
          </div>
          <br />
          <table style="width: 100%">
            <tr>
              <td>Slightly drier bud</td>
              <td>Stickier buds</td>
            </tr>
            <tr>
              <td>Perfect for joints</td>
              <td>Drier climates</td>
            </tr>
            <tr>
              <td>Great for pre-rolls</td>
              <td>Higher altitudes</td>
            </tr>
          </table>
          <div id="result">
            <br />
            <h3 class="center">I COULD HAVE MADE</h3>
            <h2 class="center">${{Number(savings).toLocaleString('en')}}</h2>
            <h3 class="center">MORE WITH BOVEDA</h3>
          </div>
        </div>
        <div
          class="center note"
        >Note: average humidity level determined by testing done in the US and Canada</div>
        <div class="center content">
          <a class="shop_box center" href="https://bovedainc.com/store/herbal/">SHOP NOW</a>
          <br />
          <br />
          <h2>WANT TO SEE THE RESULTS YOURSELF?</h2>
          <br />
          <a
            class="samples"
            :href="'https://4124564.extforms.netsuite.com/app/site/crm/externalleadpage.nl/compid.4124564/.f?formid=7&h=AACffht_KBwqDBD3DX8LuMkxQSWmoNF8_Kg&redirect_count=1&did_javascript_redirect=T&price=' + price + '&output=' + output + '&crh=' + currentRh + '&trh=' + targetRh + '&estroi=' + Number(savings).toLocaleString('en')"
            target="_blank"
          >CLAIM YOUR FREE SAMPLE HERE</a>
          <br />
          <br />
        </div>
        <div class="center content">
          <h2>DOING NOTHING EARNS YOU LESS, DESTROYS QUALITY</h2>
        </div>
        <div
          class="center content"
        >Unprotected flower starts to degrade immediately and loses terpenes. Losing terpenes signals loss of smell, flavor and water weight—gone forever.</div>
        <div class="center content">
          <h2>HOW USING BOVEDA PROTECTS YOUR FLOWER</h2>
        </div>
        <div
          class="center content"
        >Boveda takes flower to the precise moisture level needed to create a monolayer shield around terpenes. Without this monolayer, flower loses moisture, weight and quality.</div>
        <div class="center content" id="monolayer">
          <img src="/img/tric.png" alt />
        </div>
        <div
          class="center content"
        >Boveda maintains this shield by quickly and carefully adjusting the moisture environment inside your containers. Your result? Fresh flower— never dry, never moldy—all along the supply chain.</div>
        <div
          class="center content"
        >Simply slip in packets of Boveda with flower while she’s curing in bins, bags or jars. Boveda automatically maintains the right moisture level for buds for months.</div>
        <div class="center content">
          <h2>
            POST CURE CARE
            <br />WITH BOVEDA
          </h2>
        </div>
        <div class="center content">
          <h2 class="blue">STORING</h2>
        </div>
        <a href="https://www.bovedawholesale.com/search?custitem_fam_size=320-GRAM&industry=Cannabis">
          <div class="center content">
			  <div class="img-hover-zoom g320 img-hover-zoom--xyz">
            <img src="/img/320_bin.png" alt />
			</div>
          </div>
          <div class="center content">Boveda 320g for up to 5 lb (2.25kg)</div>
        </a>
        <a href="https://www.bovedawholesale.com/search?custitem_fam_size=60-GRAM&rh=58,62">
          <div class="center content">
			  <div class="img-hover-zoom g67 img-hover-zoom--xyz">
            <img src="/img/58_bag.png" alt />
			</div>
          </div>
          <div class="center content">Boveda 67g for up to 1 lb (450g)</div>
        </a>
        <div class="center content">
          <h2 class="blue">PACKAGING & RETAILING</h2>
        </div>
        <a href="https://www.bovedawholesale.com/search?custitem_fam_size=8-GRAM&rh=58,62">
          <div class="center content">
			  <div class="img-hover-zoom g8 img-hover-zoom--xyz">
            <img src="/img/62_jar.png" alt />
			</div>
          </div>
          <div class="center content">Boveda 8g for up to 1 oz (28g)</div>
        </a>
        <a href="https://www.bovedawholesale.com/search?custitem_fam_size=4-GRAM&rh=58,62">
          <div class="center content">
			  <div class="img-hover-zoom g4 img-hover-zoom--xyz">
            <img src="/img/58_jar.png" alt />
			</div>
          </div>
          <div class="center content">Boveda 4g for up to 1/2 oz (14g)</div>
        </a>
        <div class="center content">
          <h2 class="blue">PROTECTING CONSUMER’S MEDICINE & EXPERIENCE</h2>
        </div>
        <a href="https://www.bovedawholesale.com/search?custitem_fam_size=1-GRAM&rh=58,62">
          <div class="center content">
			  <div class="img-hover-zoom g1 img-hover-zoom--xyz">
            <img src="/img/pre-roll.png" alt />
			</div>
          </div>
          <div class="center content">
            Boveda 1g for today’s dose,
            <br />up to 1/8 oz (3.5g)
          </div>
        </a>
		<a href="https://www.bovedawholesale.com/search?keywords=slim&custitem_fam_size=1-GRAM">
        <div class="center content">
			<div class="img-hover-zoom g1s img-hover-zoom--xyz">
          <img src="/img/58_slim.png" alt />
		  </div>
        </div>
        <div class="center content">Boveda 1g SLIM for this evening’s pre-rolls</div>
		</a>
        <div class="center content">
          <a class="shop_box center" href="https://bovedainc.com/store/herbal/">SHOP NOW</a>
          <br />
          <br />
          <h2>WANT TO SEE THE RESULTS YOURSELF?</h2>
          <br />
          <a
            class="samples"
            :href="'https://4124564.extforms.netsuite.com/app/site/crm/externalleadpage.nl/compid.4124564/.f?formid=7&h=AACffht_KBwqDBD3DX8LuMkxQSWmoNF8_Kg&redirect_count=1&did_javascript_redirect=T&price=' + price + '&output=' + output + '&crh=' + currentRh + '&trh=' + targetRh + '&estroi=' + Number(savings).toLocaleString('en')"
            target="_blank"
          >CLAIM YOUR FREE SAMPLE HERE</a>
          <br />
          <br />
        </div>
        <div id="testimonial">
          <br />
          <br />
          <h2 class="center">TOP CANNABIS BRANDS IN THE WORLD USE BOVEDA</h2>
          <div>
            <div>
              <table id="testimonial-container">
                <tr>
                  <td>
                    <div id="skyhigh">
                      <img src="/img/skyhigh.png" v-observe-visibility="shv" />
                      <div>“Our cure only happens properly between certain humidity ranges, so Boveda allows us to achieve that ideal humidity time and time again.”</div>
                      <div>Phil Seda</div>
                      <div>Director of Operations</div>
                    </div>
                  </td>
                  <td>
                    <div id="medmen">
                      <img src="/img/medmen.png" v-observe-visibility="mmv" />
                      <div>“Integrating Boveda allowed us to develop a replicatable process that creates consistency, scalability and the best finished good—I can't go back to the time before we used Boveda.”</div>
                      <div>ADAM BIERMAN</div>
                      <div>CEO</div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <span class="t-nav" ref="vsh"></span>
          <span class="t-nav" ref="vmm"></span>
          <br />
          <br />
        </div>
        <div class="note center content">
          <br />
          <br />
          <table>
            <tr>
              <td>
                <img src="/img/ASTM_1.png" alt />
              </td>
              <td>
                <img src="/img/ASTM_2.png" alt />
              </td>
              <td>
                <img src="/img/ASTM_3.png" alt />
              </td>
            </tr>
          </table>
        </div>
        <div class="note center content">COMPLIES WITH ASTM INTERNATIONAL STANDARD D8197-18</div>
        <div
          class="note center content"
        >(ASTM standard recommends salt-based solutions for flower storage.)</div>
      </div>
      <div id="footer">
        <br />
        <br />
        <h2 class="center">CONTACT US</h2>
        <br />
        <br />
        <table>
          <tr>
            <td>
              <a href="https://www.facebook.com/BovedaCanna" target="_blank">
                <img src="/img/icon_facebook.png" alt />
              </a>
            </td>
            <td>
              <a href="https://twitter.com/BovedaCannabis" target="_blank">
                <img src="/img/icon_twitter.png" alt />
              </a>
            </td>
            <td>
              <a href="https://www.youtube.com/channel/UCS5hbuKrp4o80LC9d-lhYCw" target="_blank">
                <img src="/img/icon_youtube.png" alt />
              </a>
            </td>
            <td>
              <a href="https://www.instagram.com/bovedacannabis/" target="_blank">
                <img src="/img/icon_instagram.png" alt />
              </a>
            </td>
          </tr>
        </table>
        <br />
        <br />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "home",
  data: function() {
    return {
      price: 11,
      output: 2500,
      currentRh: 50,
      targetRh: 62
    };
  },
  methods: {
    shv(isVisible, entry) {
      var refs = this.$refs;
      if (isVisible) {
        refs.vsh.classList.add("active-testimonial");
      } else {
        refs.vsh.classList.remove("active-testimonial");
      }
    },
    mmv(isVisible, entry) {
      var refs = this.$refs;
      if (isVisible) {
        refs.vmm.classList.add("active-testimonial");
      } else {
        refs.vmm.classList.remove("active-testimonial");
      }
    }
  },
  computed: {
    savings: function savings() {
      let output_in_grams = this.output * 453.592;
      let currentRevenue = this.price * output_in_grams;
      let diff = this.targetRh - this.currentRh;
      let multiplier = diff * (0.022 / 10);
      if (this.currentRh >= 65) multiplier = 0;
      return (currentRevenue * multiplier).toFixed(0);
    },
    footNote: function() {
      let currentRh = this.currentRh;
      let message = "";

      if (currentRh < 50)
        message =
          "Cannabis stored in an environment below 58% RH causes terpene loss";
      if (currentRh === 50)
        message = "90% of samples we tested were 50% or below";
      if (currentRh > 50 && currentRh < 58)
        message =
          "Cannabis stored in an environment below 58% RH causes terpene loss";
      if (currentRh >= 58 && currentRh <= 62)
        message =
          "The most effective RH level to produce the monolayer which saves your terpenes and keeps your buds fresh";
      if (currentRh >= 63 && currentRh <= 64)
        message =
          "Your flower is entering the danger zone where mold and mildew starts to grow";
      if (currentRh >= 65)
        message =
          "Anything above 65% is in the unsafe zone and high risk for mold, recalls, and potential harm if consumed";
      return message;
    }
  },
  mounted() {}
};
</script>>
<style lang="scss">
$blbrown: #e3c19f;
$bbrown: #654c40;
$bblue: #7eddd3;
$borange: #ff5100;

@import "@/assets/reset.scss";

/* Fonts */
@font-face {
  font-family: gotham;
  src: url("assets/fonts/Gotham-Bold.ttf");
  font-weight: bold;
}

@font-face {
  font-family: gotham;
  src: url("assets/fonts/Gotham-Medium.ttf");
  font-weight: 500;
}

@font-face {
  font-family: gotham;
  src: url("assets/fonts/Gotham-Light.ttf");
  font-weight: light;
}

/* Helpers */
.center {
  text-align: center;
  margin: 0 auto;
}

* {
  box-sizing: border-box;
}

.blue {
  color: $bblue;
}

body {
  ul {
    padding: 25px;
  }

  h1 {
    font-size: 2.3em;
  }

  h2 {
    font-size: 1.4em;
    font-weight: 600;
  }

  h3 {
    font-size: 1.2em;
  }

  h4 {
    font-size: 1em;
  }

  h5 {
    font-size: 0.8em;
  }

  h6 {
    font-size: 0.6em;
  }

  font-family: "gotham";
  font-weight: 500;
  color: #654c40;
  background: #fff;

  nav {
    width: 100%;
    top: 0;
    background-color: $bbrown;
    position: fixed;
    padding: 10px;
  }
  a {
    text-decoration: none;
    color: $bbrown;
  }
  .container {
    padding: 56px 0 0 0;
    margin: 0;
/* [1] The container */
.img-hover-zoom {
  overflow: hidden; /* [1.2] Hide the overflowing of child elements */
}

.g320 img {
  transform-origin: 74% 50%;
  transition: transform .5s, filter .5s ease-out;
}

.g320:hover img {
  transform: scale(2.5);
}
.g67 img {
  transform-origin: 63% 65%;
  transition: transform .5s, filter .5s ease-out;
}

.g67:hover img {
  transform: scale(2.5);
}
.g8 img {
  transform-origin: 30% 75%;
  transition: transform .5s, filter .5s ease-out;
}

.g8:hover img {
  transform: scale(1.8) rotate(43deg);
}
.g4 img {
  transform-origin: 55% 50%;
  transition: transform .5s, filter .5s ease-out;
}

.g4:hover img {
  transform: scale(2.5) rotate(19deg);
}
.g1 img {
  transform-origin: 46% 46%;
  transition: transform .5s, filter .5s ease-out;
}

.g1:hover img {
  transform: scale(2.5) rotate(11deg);
}
.g1s img {
  transform-origin: 42% 60%;
  transition: transform .5s, filter .5s ease-out;
}

.g1s:hover img {
  transform: scale(2.3) rotate(-13deg);
}
    #splash {
      display: table-cell;
      background: url("/img/splash.png");
      background-size: cover;
      height: 340px;
      vertical-align: middle;

      h1 {
        color: #fff;
      }
    }

    .content {
      margin: 25px;
      max-width: 430px;
      font-size: 1.2em;
      line-height: 1.5em;

      &#monolayer > img {
        border: 5px solid $bblue;
      }

      img {
        width: 100%;
      }

      .shop_box {
        text-decoration: none;
        display: block;
        color: #fff;
        background-color: $bblue;
        width: 330px;
        padding: 23px;
        font-size: 1.3em;
        cursor: pointer;
      }

      .samples {
        text-decoration: none;
        color: $bblue;
        border-bottom: 2px solid $bblue;
        font-weight: 800;
        font-size: 1.1em;
      }
    }

    #testimonial {
      margin: 15px;
      border: #000 solid 2px;
      width: calc(100% - 30px);
      overflow: hidden;

      h2 {
        max-width: 400px;
      }

      & > div {
        width: 100%;
        overflow-y: scroll;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
          display: none;
        }

        & > div {
          width: 200%;

          table#testimonial-container {
            width: 100%;

            tr {
              width: 100%;

              td {
                width: 50%;

                div {
                  img {
                    border-radius: 50%;
                    border: solid 4px $bblue;
                    width: 140px;
                    margin: 30px auto;
                    display: block;
                  }

                  div:nth-of-type(1) {
                    font-size: 1.2em;
                    padding: 15px;
                  }

                  div:nth-of-type(2) {
                    padding: 20px;
                    text-transform: uppercase;
                    font-size: 1.5em;
                    font-weight: 800;
                  }

                  div:nth-of-type(3) {
                    font-size: 1.5em;
                    font-weight: 400;
                  }
                }
              }
            }
          }
        }
      }

      .t-nav {
        margin: 5px;
        display: inline-block;
        border-radius: 50%;
        border: 2px solid grey;
        background-color: #d4d1d1;
        height: 15px;
        width: 15px;

        &.active-testimonial {
          background-color: grey;
        }
      }
    }

    .note {
      margin: 25px;
      max-width: 430px;
      font-size: 1em;
      line-height: 1.5em;
      font-weight: 300;

      &.center {
        &.content {
          table {
            margin: 0 auto;
            width: 60%;

            tr {
              td {
                width: 33%;

                img {
                  width: 80%;
                }
              }
            }
          }
        }
      }
    }
  }
}

#calculator {
  h2 {
    max-width: 400px;
    font-weight: 500;
    padding: 15px;
    font-size: 2em;
    line-height: 1.2em;
  }

  margin: 5px;
  border: $bbrown solid 2px;

  .blue_banner {
    background-color: $bblue;
    padding: 20px;

    h3 {
      font-size: 1.5em;
      font-weight: 500;
    }
  }

  .toggleContainer {
    border: $bbrown solid 5px;
    margin: 5px;
    background-color: $bbrown;

    .currency {
      color: white;
      padding: 5px;
      width: 50%;
      float: left;
      cursor: pointer;
    }

    .hr {
      color: white;
      padding: 5px;
      width: 50%;
      float: left;
      cursor: pointer;
    }

    .selected {
      background-color: $bblue;
    }
  }

  .slider {
    h4 {
      font-size: 1.5em;
      line-height: 1.3em;
      font-weight: 510;
      margin: 35px 65px 15px 65px;
    }

    input[type="range"] {
      margin: 0 25px 15px;
    }

    margin: 5px;
    border-bottom: 3px dashed $bbrown;

    .slider_common {
      -webkit-appearance: none;
      appearance: none;
      width: calc(100% - 50px);
      height: 25px;
      outline: none;
      height: 10px;
      border-radius: 10px;
      padding: 6px;

      &::-webkit-slider-thumb {
        -webkit-appearance: none;
        /* Override default look */
        appearance: none;
        width: 40px;
        /* Set a specific slider handle width */
        height: 40px;
        /* Slider handle height */
        background: $bblue;
        /* Green background */
        cursor: pointer;
        /* Cursor on hover */
        border-radius: 50%;
      }

      &::-moz-range-thumb {
        width: 40px;
        /* Set a specific slider handle width */
        height: 40px;
        /* Slider handle height */
        background: $bblue;
        /* Green background */
        cursor: pointer;
        /* Cursor on hover */
        border-radius: 50%;
      }
    }

    .brown_slider {
      background: $bbrown;
    }

    .rainbow_slider {
      background-image: linear-gradient(
        to right,
        #b94a48 25%,
        #f1c40f 35%,
        #4bc67d 50%,
        #f1c40f 65%,
        #b94a48 75%
      );
    }
  }

  #result {
    border-top: 3px dashed $bbrown;

    h3 {
      padding: 20px;
      font-weight: 800;
      font-size: 1.4em;
    }

    color: #fff;
    margin: 15px;
    color: $bbrown;

    h2 {
      color: #85bb65;
      padding: 0;
      font-size: 2.5em;
    }
  }

  table tr > td {
    &:nth-child(even) {
      padding: 0 10px 10px 0;
      text-align: center;
    }

    &:nth-child(odd) {
      padding: 0 0 0 10px;
      text-align: center;
    }
  }
}

#footer {
  color: $blbrown;
  background-color: $bbrown;

  & > table {
    margin: 0 auto;
    width: 400px;

    tr {
      td {
        width: 25%;

        img {
          width: 60%;
        }
      }
    }
  }
}
</style>
